import { useEffect } from 'react';
import chatbot from '../../../core/helpers/chatbot';

type Props = {
  propertyId?: string;
  propertyName?: string;
  locale?: string;
  chatbotKey?: string;
};

const Chatbot = (props: Props) => {
  const { propertyId, propertyName, locale, chatbotKey } = props;

  useEffect(() => {
    if (propertyId && propertyName && locale) {
      chatbot.initialize(propertyId, propertyName, locale, chatbotKey);
    } else if (chatbotKey) {
      chatbot.initialize(undefined, undefined, undefined, chatbotKey);
    }

    return () => {
      chatbot.cleanup();
    };
  }, [locale, propertyId, propertyName, chatbotKey]);

  return null;
};

export default Chatbot;
